import React from 'react';
import { Alert, AlertTitle, Box, Typography } from '@mui/material';

/**
 * Guía de proceso con pasos numerados.
 * @param {string} title
 * @param {string[]} steps
 * @param {'info'|'success'|'warning'|'error'} [severity='info']
 */
export default function ProcessGuide({ title = 'Cómo continuar', steps = [], severity = 'info' }) {
    if (!steps || steps.length === 0) return null;

    return (
        <Alert severity={severity} sx={{ mb: 2 }}>
            {title ? <AlertTitle>{title}</AlertTitle> : null}
            <Box component="ol" sx={{ m: 0, pl: 2.5 }}>
                {steps.map((step, idx) => (
                    <Typography component="li" variant="body2" key={idx} sx={{ mb: 0.5 }}>
                        {step}
                    </Typography>
                ))}
            </Box>
        </Alert>
    );
}
